module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('top-nav', {
    attrs: {
      "isWhite": false,
      "hasLogo": true,
      "lang": _vm.$route.params.lang
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "flex flex-column"
  }, [_c('articles-list', {
    attrs: {
      "lang": _vm.$route.params.lang,
      "standalone": true
    }
  })], 1), _vm._v(" "), _c('footer-bar', {
    attrs: {
      "lang": _vm.$route.params.lang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70fb1837","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticlesHome.vue
// module id = 126
// module chunks = 0